module.exports = __webpack_public_path__ + "img/2.aba2731b.jpg";